import React from'react';import PropTypes from'prop-types';import FormattedRichMessage from'../FormattedRichMessage/FormattedRichMessage.js';var ValidationErrorShape = process.env.NODE_ENV !== "production" ? PropTypes.shape({
  message: PropTypes.string.isRequired
}) : {};
var CombinedValidationErrorMessage = function CombinedValidationErrorMessage(_ref) {
  var combinedLabel = _ref.combinedLabel,
    errors = _ref.errors;
  return /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "shared.validation.combined",
    values: {
      combinedLabel: combinedLabel,
      errors: /*#__PURE__*/React.createElement("ul", null, errors === null || errors === void 0 ? void 0 : errors.map(function ErrorListItem(err) {
        var _err$context, _err$context$label;
        return /*#__PURE__*/React.createElement("li", {
          key: err.message
        }, /*#__PURE__*/React.createElement(FormattedRichMessage, {
          id: "".concat(err.message, ".combined"),
          values: {
            fieldName: err === null || err === void 0 ? void 0 : (_err$context = err.context) === null || _err$context === void 0 ? void 0 : (_err$context$label = _err$context.label) === null || _err$context$label === void 0 ? void 0 : _err$context$label.toLowerCase()
          }
        }));
      }))
    }
  });
};
process.env.NODE_ENV !== "production" ? CombinedValidationErrorMessage.propTypes = {
  combinedLabel: PropTypes.string.isRequired,
  errors: PropTypes.arrayOf(ValidationErrorShape).isRequired
} : void 0;
var CombinedValidationErrorMessage$1 = CombinedValidationErrorMessage;export{CombinedValidationErrorMessage$1 as default};